export const RightArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.293 3.29279C10.4805 3.10532 10.7348 3 11 3C11.2652 3 11.5195 3.10532 11.707 3.29279L17.707 9.29279C17.8945 9.48031 17.9998 9.73462 17.9998 9.99979C17.9998 10.265 17.8945 10.5193 17.707 10.7068L11.707 16.7068C11.5184 16.8889 11.2658 16.9897 11.0036 16.9875C10.7414 16.9852 10.4906 16.88 10.3052 16.6946C10.1198 16.5092 10.0146 16.2584 10.0123 15.9962C10.01 15.734 10.1108 15.4814 10.293 15.2928L14.586 10.9998H3C2.73478 10.9998 2.48043 10.8944 2.29289 10.7069C2.10536 10.5194 2 10.265 2 9.99979C2 9.73457 2.10536 9.48022 2.29289 9.29268C2.48043 9.10514 2.73478 8.99979 3 8.99979H14.586L10.293 4.70679C10.1055 4.51926 10.0002 4.26495 10.0002 3.99979C10.0002 3.73462 10.1055 3.48031 10.293 3.29279Z"
        fill="white"
      />
    </svg>
  );
};

export const CircleIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V10C5 10.2652 5.10536 10.5196 5.29289 10.7071C5.48043 10.8946 5.73478 11 6 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5H6Z"
        fill="white"
      />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12.3065L3.66667 9.83802M3.66667 9.83802L13 1.19818L22.3333 9.83802M3.66667 9.83802V22.1806C3.66667 22.508 3.80714 22.8219 4.05719 23.0534C4.30724 23.2849 4.64638 23.4149 5 23.4149H9M22.3333 9.83802L25 12.3065M22.3333 9.83802V22.1806C22.3333 22.508 22.1929 22.8219 21.9428 23.0534C21.6928 23.2849 21.3536 23.4149 21 23.4149H17M9 23.4149C9.35362 23.4149 9.69276 23.2849 9.94281 23.0534C10.1929 22.8219 10.3333 22.508 10.3333 22.1806V17.2436C10.3333 16.9162 10.4738 16.6023 10.7239 16.3708C10.9739 16.1394 11.313 16.0093 11.6667 16.0093H14.3333C14.687 16.0093 15.0261 16.1394 15.2761 16.3708C15.5262 16.6023 15.6667 16.9162 15.6667 17.2436V22.1806C15.6667 22.508 15.8071 22.8219 16.0572 23.0534C16.3072 23.2849 16.6464 23.4149 17 23.4149M9 23.4149H17"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5ZM12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125Z"
        fill="white"
      />
      <path
        d="M13.125 7.875C13.125 7.57663 13.0065 7.29048 12.7955 7.07951C12.5845 6.86853 12.2984 6.75 12 6.75C11.7016 6.75 11.4155 6.86853 11.2045 7.07951C10.9935 7.29048 10.875 7.57663 10.875 7.875C10.875 8.17337 10.9935 8.45952 11.2045 8.67049C11.4155 8.88147 11.7016 9 12 9C12.2984 9 12.5845 8.88147 12.7955 8.67049C13.0065 8.45952 13.125 8.17337 13.125 7.875ZM12.5625 10.5H11.4375C11.3344 10.5 11.25 10.5844 11.25 10.6875V17.0625C11.25 17.1656 11.3344 17.25 11.4375 17.25H12.5625C12.6656 17.25 12.75 17.1656 12.75 17.0625V10.6875C12.75 10.5844 12.6656 10.5 12.5625 10.5Z"
        fill="white"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.17 13.71L15.57 11.29C15.66 11.14 15.62 10.95 15.49 10.84L14.01 9.68C14.04 9.46 14.06 9.23 14.06 9C14.06 8.77 14.04 8.54 14.01 8.31L15.49 7.15C15.62 7.04 15.66 6.85 15.57 6.7L14.17 4.28C14.08 4.13 13.9 4.07 13.74 4.13L12 4.83C11.64 4.55 11.25 4.32 10.82 4.14L10.56 2.29C10.5432 2.20912 10.4994 2.13636 10.4358 2.08366C10.3722 2.03096 10.2926 2.00145 10.21 2H7.41C7.24 2 7.09 2.13 7.06 2.3L6.8 4.15C6.38 4.33 5.98 4.56 5.62 4.84L3.88 4.14C3.72 4.08 3.54 4.14 3.45 4.29L2.05 6.71C1.96 6.86 2 7.05 2.13 7.16L3.61 8.32C3.58 8.54 3.56 8.77 3.56 9C3.56 9.23 3.58 9.46 3.61 9.69L2.13 10.85C2 10.96 1.96 11.15 2.05 11.3L3.45 13.72C3.54 13.87 3.72 13.93 3.88 13.87L5.62 13.17C5.98 13.45 6.37 13.68 6.8 13.86L7.06 15.71C7.09 15.87 7.24 16 7.41 16H10.21C10.38 16 10.53 15.87 10.56 15.7L10.82 13.85C11.24 13.67 11.64 13.44 12 13.16L13.74 13.86C13.9 13.92 14.08 13.86 14.17 13.71ZM8.81 11C7.71 11 6.81 10.1 6.81 9C6.81 7.9 7.71 7 8.81 7C9.91 7 10.81 7.9 10.81 9C10.81 10.1 9.91 11 8.81 11ZM21.92 18.67L20.96 17.93C20.98 17.79 21 17.64 21 17.49C21 17.34 20.99 17.19 20.96 17.05L21.91 16.31C21.99 16.24 22.02 16.12 21.96 16.02L21.06 14.47C21.01 14.37 20.89 14.34 20.78 14.37L19.67 14.82C19.44 14.64 19.19 14.49 18.91 14.38L18.74 13.2C18.736 13.1466 18.7124 13.0965 18.6736 13.0595C18.6347 13.0226 18.5836 13.0013 18.53 13H16.74C16.63 13 16.53 13.08 16.52 13.19L16.35 14.37C16.08 14.49 15.82 14.63 15.59 14.81L14.48 14.36C14.429 14.3408 14.3729 14.3404 14.3217 14.3587C14.2704 14.377 14.2273 14.4129 14.2 14.46L13.3 16.01C13.25 16.11 13.26 16.23 13.35 16.3L14.3 17.04C14.2588 17.3319 14.2588 17.6281 14.3 17.92L13.35 18.66C13.27 18.73 13.24 18.85 13.3 18.95L14.2 20.5C14.25 20.6 14.37 20.63 14.48 20.6L15.59 20.15C15.82 20.33 16.07 20.48 16.35 20.59L16.52 21.77C16.54 21.88 16.63 21.96 16.74 21.96H18.53C18.64 21.96 18.74 21.88 18.75 21.77L18.92 20.59C19.19 20.47 19.45 20.33 19.67 20.15L20.79 20.6C20.89 20.64 21.01 20.6 21.07 20.5L21.97 18.95C22.03 18.86 22 18.74 21.92 18.67ZM17.63 18.83C17.2718 18.8299 16.9284 18.6875 16.6752 18.4341C16.422 18.1807 16.2799 17.8372 16.28 17.479C16.2801 17.1208 16.4225 16.7774 16.6759 16.5242C16.9293 16.271 17.2728 16.1289 17.631 16.129C17.9892 16.1291 18.3326 16.2715 18.5858 16.5249C18.839 16.7783 18.9811 17.1218 18.981 17.48C18.9809 17.8382 18.8385 18.1816 18.5851 18.4348C18.3317 18.688 17.9882 18.8301 17.63 18.83Z"
        fill="white"
      />
    </svg>
  );
};

export const SkillsIcon = () => {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7779 1.85932C13.1634 0.713561 14.8381 0.713561 15.2224 1.85932L17.1746 7.67393C17.2586 7.92335 17.422 8.14067 17.6412 8.29484C17.8605 8.449 18.1246 8.53213 18.3956 8.53232H24.7124C25.9578 8.53232 26.4745 10.0749 25.4681 10.784L20.3581 14.3768C20.1386 14.5313 19.9752 14.749 19.8914 14.9989C19.8076 15.2487 19.8077 15.5178 19.8916 15.7676L21.8425 21.5822C22.2281 22.7292 20.8722 23.6822 19.8659 22.9731L14.7558 19.3803C14.5362 19.2258 14.2716 19.1425 14.0001 19.1425C13.7286 19.1425 13.464 19.2258 13.2444 19.3803L8.13437 22.9731C7.12804 23.6822 5.77214 22.728 6.1577 21.5822L8.10867 15.7676C8.19256 15.5178 8.19261 15.2487 8.10881 14.9989C8.025 14.749 7.86164 14.5313 7.64213 14.3768L2.53209 10.784C1.52448 10.0749 2.04371 8.53232 3.2878 8.53232H9.60338C9.87462 8.53239 10.1389 8.44939 10.3585 8.2952C10.578 8.14102 10.7415 7.92355 10.8256 7.67393L12.7779 1.85932V1.85932Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ArticlesIcon = () => {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3H25V21H3V3ZM5 5V19H23V5H5ZM9 8H19V10H9V8ZM9 12H14V14H9V12ZM9 16H12V18H9V16Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MailIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
        fill="white"
      />
    </svg>
  );
};

export const ResumeIcon = () => {
  return (
    <svg
      width="150"
      height="150"
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M90.625 62.5C85.4375 62.5 81.25 58.3125 81.25 53.125V21.875C81.25 16.6875 85.4375 12.5 90.625 12.5C95.8125 12.5 100 16.6875 100 21.875V53.125C100 58.3125 95.8125 62.5 90.625 62.5Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.125 62.5H118.75V53.125C118.75 47.9375 122.938 43.75 128.125 43.75C133.312 43.75 137.5 47.9375 137.5 53.125C137.5 58.3125 133.312 62.5 128.125 62.5Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M59.375 87.5C64.5625 87.5 68.75 91.6875 68.75 96.875V128.125C68.75 133.312 64.5625 137.5 59.375 137.5C54.1875 137.5 50 133.312 50 128.125V96.875C50 91.6875 54.1875 87.5 59.375 87.5Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.875 87.5H31.25V96.875C31.25 102.062 27.0625 106.25 21.875 106.25C16.6875 106.25 12.5 102.062 12.5 96.875C12.5 91.6875 16.6875 87.5 21.875 87.5Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M87.5 90.625C87.5 85.4375 91.6875 81.25 96.875 81.25H128.125C133.312 81.25 137.5 85.4375 137.5 90.625C137.5 95.8125 133.312 100 128.125 100H96.875C91.6875 100 87.5 95.8125 87.5 90.625Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M96.875 118.75H87.5V128.125C87.5 133.312 91.6875 137.5 96.875 137.5C102.062 137.5 106.25 133.312 106.25 128.125C106.25 122.938 102.062 118.75 96.875 118.75Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M62.5 59.375C62.5 54.1875 58.3125 50 53.125 50H21.875C16.6875 50 12.5 54.1875 12.5 59.375C12.5 64.5625 16.6875 68.75 21.875 68.75H53.125C58.3125 68.75 62.5 64.5625 62.5 59.375Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.125 31.25H62.5V21.875C62.5 16.6875 58.3125 12.5 53.125 12.5C47.9375 12.5 43.75 16.6875 43.75 21.875C43.75 27.0625 47.9375 31.25 53.125 31.25Z"
        stroke="#FFC000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 15C0 14.7348 0.105357 14.4804 0.292893 14.2929C0.48043 14.1054 0.734784 14 1 14H13C13.2652 14 13.5196 14.1054 13.7071 14.2929C13.8946 14.4804 14 14.7348 14 15C14 15.2652 13.8946 15.5196 13.7071 15.7071C13.5196 15.8946 13.2652 16 13 16H1C0.734784 16 0.48043 15.8946 0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15ZM3.293 7.293C3.48053 7.10553 3.73484 7.00021 4 7.00021C4.26516 7.00021 4.51947 7.10553 4.707 7.293L6 8.586V1C6 0.734784 6.10536 0.48043 6.29289 0.292893C6.48043 0.105357 6.73478 0 7 0C7.26522 0 7.51957 0.105357 7.70711 0.292893C7.89464 0.48043 8 0.734784 8 1V8.586L9.293 7.293C9.38525 7.19749 9.49559 7.12131 9.6176 7.0689C9.7396 7.01649 9.87082 6.9889 10.0036 6.98775C10.1364 6.9866 10.2681 7.0119 10.391 7.06218C10.5139 7.11246 10.6255 7.18671 10.7194 7.28061C10.8133 7.3745 10.8875 7.48615 10.9378 7.60905C10.9881 7.73194 11.0134 7.86362 11.0123 7.9964C11.0111 8.12918 10.9835 8.2604 10.9311 8.3824C10.8787 8.50441 10.8025 8.61475 10.707 8.707L7.707 11.707C7.51947 11.8945 7.26516 11.9998 7 11.9998C6.73484 11.9998 6.48053 11.8945 6.293 11.707L3.293 8.707C3.10553 8.51947 3.00021 8.26516 3.00021 8C3.00021 7.73484 3.10553 7.48053 3.293 7.293Z"
        fill="white"
      />
    </svg>
  );
};

export const MailIconYellow = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.41 9.61812C3.97852 9.88779 3.62273 10.2628 3.37607 10.7078C3.12941 11.1528 3 11.6533 3 12.1621V24.0001C3 24.7958 3.31607 25.5588 3.87868 26.1214C4.44129 26.684 5.20435 27.0001 6 27.0001H24C24.7956 27.0001 25.5587 26.684 26.1213 26.1214C26.6839 25.5588 27 24.7958 27 24.0001V12.1621C27 11.6533 26.8706 11.1528 26.6239 10.7078C26.3773 10.2628 26.0215 9.88779 25.59 9.61812L16.59 3.99312C16.1132 3.69512 15.5623 3.53711 15 3.53711C14.4377 3.53711 13.8868 3.69512 13.41 3.99312L4.41 9.61812ZM8.3325 13.2526C8.16861 13.1433 7.98479 13.0673 7.79154 13.029C7.59829 12.9907 7.39939 12.9909 7.2062 13.0295C7.013 13.0681 6.8293 13.1443 6.66558 13.2539C6.50186 13.3635 6.36133 13.5042 6.252 13.6681C6.14267 13.832 6.0667 14.0158 6.02841 14.2091C5.99013 14.4023 5.99028 14.6012 6.02886 14.7944C6.10679 15.1846 6.33651 15.5278 6.6675 15.7486L14.1675 20.7481C14.414 20.9126 14.7037 21.0003 15 21.0003C15.2963 21.0003 15.586 20.9126 15.8325 20.7481L23.3325 15.7486C23.6635 15.5278 23.8932 15.1846 23.9711 14.7944C24.0491 14.4043 23.9688 13.9991 23.748 13.6681C23.5272 13.3371 23.184 13.1074 22.7938 13.0295C22.4036 12.9516 21.9985 13.0318 21.6675 13.2526L15 17.6971L8.3325 13.2526Z"
        fill="#FFC000"
      />
    </svg>
  );
};

export const CallIconYellow = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H7.7295C8.08456 3.00016 8.42805 3.12627 8.69887 3.35589C8.96968 3.58551 9.15027 3.90375 9.2085 4.254L10.3185 10.9065C10.3715 11.2233 10.3215 11.5488 10.1756 11.835C10.0298 12.1213 9.79597 12.3531 9.5085 12.4965L7.1865 13.656C8.01916 15.7195 9.25925 17.5939 10.8327 19.1673C12.4061 20.7408 14.2805 21.9808 16.344 22.8135L17.505 20.4915C17.6483 20.2043 17.8799 19.9706 18.1658 19.8248C18.4518 19.679 18.7769 19.6288 19.0935 19.6815L25.746 20.7915C26.0963 20.8497 26.4145 21.0303 26.6441 21.3011C26.8737 21.572 26.9998 21.9154 27 22.2705V25.5C27 25.8978 26.842 26.2794 26.5607 26.5607C26.2794 26.842 25.8978 27 25.5 27H22.5C11.73 27 3 18.27 3 7.5V4.5Z"
        fill="#FFC000"
      />
    </svg>
  );
};

export const SendIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2L11 13"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MailIconBlack = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_49_427)">
        <path
          d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
          fill="black"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23 6L12 14L1 6"
          stroke="#FFC000"
          stroke-width="2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49_427">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedInIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z"
        fill="black"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 9H2V21H6V9Z"
        fill="black"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
        fill="black"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 3H15C13.6739 3 12.4021 3.52678 11.4645 4.46447C10.5268 5.40215 10 6.67392 10 8V11H7V15H10V23H14V15H17L18 11H14V8C14 7.73478 14.1054 7.48043 14.2929 7.29289C14.4804 7.10536 14.7348 7 15 7H18V3Z"
        fill="black"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InstaIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9567 11.3698C16.0802 12.2021 15.938 13.052 15.5505 13.7988C15.163 14.5456 14.5499 15.1512 13.7984 15.5295C13.0468 15.9077 12.1952 16.0394 11.3645 15.9057C10.5339 15.7721 9.7665 15.3799 9.17158 14.785C8.57666 14.1901 8.18447 13.4227 8.05081 12.592C7.91714 11.7614 8.0488 10.9097 8.42706 10.1582C8.80533 9.40667 9.41092 8.79355 10.1577 8.40605C10.9045 8.01856 11.7545 7.8764 12.5867 7.99981C13.4357 8.1257 14.2216 8.52128 14.8284 9.12812C15.4353 9.73496 15.8309 10.5209 15.9567 11.3698Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 6.5H12.01"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GithubIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_120_2774)">
        <path
          d="M8.49121 19.4043C8.49121 19.502 8.37891 19.5801 8.2373 19.5801C8.07617 19.5947 7.96387 19.5166 7.96387 19.4043C7.96387 19.3066 8.07617 19.2285 8.21777 19.2285C8.36426 19.2139 8.49121 19.292 8.49121 19.4043ZM6.97266 19.1846C6.93848 19.2822 7.03613 19.3945 7.18262 19.4238C7.30957 19.4727 7.45605 19.4238 7.48535 19.3262C7.51465 19.2285 7.42188 19.1162 7.27539 19.0723C7.14844 19.0381 7.00684 19.0869 6.97266 19.1846ZM9.13086 19.1016C8.98926 19.1357 8.8916 19.2285 8.90625 19.3408C8.9209 19.4385 9.04785 19.502 9.19434 19.4678C9.33594 19.4336 9.43359 19.3408 9.41895 19.2432C9.4043 19.1504 9.27246 19.0869 9.13086 19.1016ZM12.3438 0.390625C5.57129 0.390625 0.390625 5.53223 0.390625 12.3047C0.390625 17.7197 3.79883 22.3535 8.66699 23.9844C9.29199 24.0967 9.51172 23.7109 9.51172 23.3936C9.51172 23.0908 9.49707 21.4209 9.49707 20.3955C9.49707 20.3955 6.0791 21.1279 5.36133 18.9404C5.36133 18.9404 4.80469 17.5195 4.00391 17.1533C4.00391 17.1533 2.88574 16.3867 4.08203 16.4014C4.08203 16.4014 5.29785 16.499 5.9668 17.6611C7.03613 19.5459 8.82813 19.0039 9.52637 18.6816C9.63867 17.9004 9.95605 17.3584 10.3076 17.0361C7.57813 16.7334 4.82422 16.3379 4.82422 11.6406C4.82422 10.2979 5.19531 9.62402 5.97656 8.76465C5.84961 8.44727 5.43457 7.13867 6.10352 5.44922C7.12402 5.13184 9.47266 6.76758 9.47266 6.76758C10.4492 6.49414 11.499 6.35254 12.5391 6.35254C13.5791 6.35254 14.6289 6.49414 15.6055 6.76758C15.6055 6.76758 17.9541 5.12695 18.9746 5.44922C19.6436 7.14355 19.2285 8.44727 19.1016 8.76465C19.8828 9.62891 20.3613 10.3027 20.3613 11.6406C20.3613 16.3525 17.4854 16.7285 14.7559 17.0361C15.2051 17.4219 15.5859 18.1543 15.5859 19.3018C15.5859 20.9473 15.5713 22.9834 15.5713 23.3838C15.5713 23.7012 15.7959 24.0869 16.416 23.9746C21.2988 22.3535 24.6094 17.7197 24.6094 12.3047C24.6094 5.53223 19.1162 0.390625 12.3438 0.390625ZM5.13672 17.2314C5.07324 17.2803 5.08789 17.3926 5.1709 17.4854C5.24902 17.5635 5.36133 17.5977 5.4248 17.5342C5.48828 17.4854 5.47363 17.373 5.39063 17.2803C5.3125 17.2021 5.2002 17.168 5.13672 17.2314ZM4.60938 16.8359C4.5752 16.8994 4.62402 16.9775 4.72168 17.0264C4.7998 17.0752 4.89746 17.0605 4.93164 16.9922C4.96582 16.9287 4.91699 16.8506 4.81934 16.8018C4.72168 16.7725 4.64355 16.7871 4.60938 16.8359ZM6.19141 18.5742C6.11328 18.6377 6.14258 18.7842 6.25488 18.877C6.36719 18.9893 6.50879 19.0039 6.57227 18.9258C6.63574 18.8623 6.60645 18.7158 6.50879 18.623C6.40137 18.5107 6.25488 18.4961 6.19141 18.5742ZM5.63477 17.8564C5.55664 17.9053 5.55664 18.0322 5.63477 18.1445C5.71289 18.2568 5.84473 18.3057 5.9082 18.2568C5.98633 18.1934 5.98633 18.0664 5.9082 17.9541C5.83984 17.8418 5.71289 17.793 5.63477 17.8564Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_120_2774">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WhatsappIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1611 4.74121C18.1152 2.69043 15.3906 1.5625 12.4951 1.5625C6.51855 1.5625 1.65527 6.42578 1.65527 12.4023C1.65527 14.3115 2.15332 16.1768 3.10059 17.8223L1.5625 23.4375L7.30957 21.9287C8.8916 22.793 10.6738 23.2471 12.4902 23.2471H12.4951C18.4668 23.2471 23.4375 18.3838 23.4375 12.4072C23.4375 9.51172 22.207 6.79199 20.1611 4.74121V4.74121ZM12.4951 21.4209C10.874 21.4209 9.28711 20.9863 7.90527 20.166L7.57812 19.9707L4.16992 20.8643L5.07812 17.5391L4.86328 17.1973C3.95996 15.7617 3.48633 14.1064 3.48633 12.4023C3.48633 7.43652 7.5293 3.39355 12.5 3.39355C14.9072 3.39355 17.168 4.33105 18.8672 6.03516C20.5664 7.73926 21.6113 10 21.6064 12.4072C21.6064 17.3779 17.4609 21.4209 12.4951 21.4209V21.4209ZM17.4365 14.6729C17.168 14.5361 15.835 13.8818 15.5859 13.7939C15.3369 13.7012 15.1563 13.6572 14.9756 13.9307C14.7949 14.2041 14.2773 14.8096 14.1162 14.9951C13.96 15.1758 13.7988 15.2002 13.5303 15.0635C11.9385 14.2676 10.8936 13.6426 9.84375 11.8408C9.56543 11.3623 10.1221 11.3965 10.6396 10.3613C10.7275 10.1807 10.6836 10.0244 10.6152 9.8877C10.5469 9.75098 10.0049 8.41797 9.78027 7.87598C9.56055 7.34863 9.33594 7.42188 9.16992 7.41211C9.01367 7.40234 8.83301 7.40234 8.65234 7.40234C8.47168 7.40234 8.17871 7.4707 7.92969 7.73926C7.68066 8.0127 6.98242 8.66699 6.98242 10C6.98242 11.333 7.9541 12.6221 8.08594 12.8027C8.22266 12.9834 9.99512 15.7178 12.7148 16.8945C14.4336 17.6367 15.1074 17.7002 15.9668 17.5732C16.4893 17.4951 17.5684 16.9189 17.793 16.2842C18.0176 15.6494 18.0176 15.1074 17.9492 14.9951C17.8857 14.873 17.7051 14.8047 17.4365 14.6729Z"
        fill="black"
      />
    </svg>
  );
};
